import React from 'react';
import {Box, Typography} from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import PanelChangeTitle from './PanelChangeTitle';
import PanelChangeActors from './PanelChangeActors';

const PanelChangeRow = ({
  classes,
  primaryLine,
  secondaryLine = null,
  oldValue,
  newValue,
  showValues = true,
  valueTone = 'default',
  footer,
  actors = null,
  flush = false,
  hideLabels = false,
  singleValue = false,
  rowClassName = '',
  sspLogo = null,
  isTagLevel = false,
}) => {
  const newValueClassName =
    valueTone === 'disabled'
      ? classes.disabledValue
      : valueTone === 'enabled'
        ? classes.newValue
        : classes.newValue;

  const showFooter = Boolean(footer || actors?.length);

  return (
    <Box className={`${classes.row} ${flush ? classes.rowFlush : ''} ${rowClassName}`.trim()}>
      {!hideLabels ? (
        <PanelChangeTitle
          classes={classes}
          primaryLine={primaryLine}
          secondaryLine={secondaryLine}
          sspLogo={sspLogo}
          isTagLevel={isTagLevel}
        />
      ) : null}
      {showValues ? (
        <Box className={`${classes.values} ${hideLabels ? classes.valuesFlush : ''}`}>
          {singleValue ? (
            <Typography variant="body2" component="span" className={newValueClassName}>
              {newValue}
            </Typography>
          ) : (
            <>
              <Typography variant="body2" component="span" className={classes.oldValue}>
                {oldValue}
              </Typography>
              <ArrowRightAltIcon className={classes.arrow} />
              <Typography variant="body2" component="span" className={newValueClassName}>
                {newValue}
              </Typography>
            </>
          )}
        </Box>
      ) : null}
      {showFooter ? (
        <Box
          className={`${classes.rowFooter} ${!footer ? classes.rowFooterActorOnly : ''}`.trim()}
        >
          {actors?.length ? <PanelChangeActors classes={classes} actors={actors} /> : <span />}
          {footer ? (
            <Typography variant="caption" component="span" className={classes.time}>
              {footer}
            </Typography>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default React.memo(PanelChangeRow);
